export type AssistantScreen = "requestList" | "taskEfficiency" | "requestDetail" | "throughput" | "operations";

/**
 * Empty-state starter prompts, per screen (PRD §2.3). Kept short so they fit the panel; clicking
 * one sends it as the user's message.
 */
export const SUGGESTED_PROMPTS: Record<AssistantScreen, string[]> = {
  // One per question mode the screen answers (2026-10-29, "Ask Claude for Ops leaders" phase 3).
  requestList: [
    "Which clients have the slowest onboarding this month?", // Rank
    "What's the median time to complete an onboarding?", // Report
    "Why are this client's onboardings slow?", // Diagnose
    "What does Slow mean?", // Define
  ],
  taskEfficiency: [
    "Which task types take the longest?", // Rank
    "Which tasks have the widest spread between median and P95?", // Report
    "Are IC Questionnaire and Contract usually assigned together?", // Report (pair sequence)
    "What does Reopen % mean?", // Define
  ],
  requestDetail: [
    "Why is this journey stuck or blocked?", // Record
    "Which stage took the longest compared with peers?", // Record
    "Who is holding the pending task, and since when?", // Record
    "What happened to the work order?", // Record
  ],
  throughput: [
    "How many onboardings did we complete each of the last 3 months?", // Report
    "Is our completion ratio keeping up with new requests?", // Trend
    "Which clients have the most requests still open?", // Rank
    "What does Open at period end mean?", // Define
  ],
  operations: [
    "What needs my attention right now?", // Triage
    "Who should I talk to about the breached work?", // Route
    "Top 10 owners by weighted load", // Rank
    "Median wait by stage", // Report
  ],
};

export const SCREEN_LABEL: Record<AssistantScreen, string> = {
  requestList: "Request List",
  taskEfficiency: "Task Efficiency",
  requestDetail: "Journey detail",
  throughput: "Throughput",
  operations: "Operations",
};
